import * as React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";

import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";
import { User } from "../../userTypes";

import ManualVerification from "./ManualVerification";

type Props = {
  external_reference: string;
  onUserChanged: (user: User) => void;
  verification?: any;
};

export default graphql<any, Props>(
  gql`
    query Verification($external_reference: ID) {
      user(external_reference: $external_reference) {
        external_reference
        email
        identity_number
        risk_assessment {
          risk_status
          created_at
          updated_at
          risk_completed
          risk_score
        }
        verification_request {
          status
          type
          created_at
          updated_at
        }
        identity_verification {
          status
          error_reason
          created_at
          updated_at
        }
        manual_verification_request {
          type
          status
          comment
          created_at
          updated_at
          error_reason
          error_source
          audit_trail
        }
      }
    }
  `,
  {
    name: "verification",
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        external_reference: props.external_reference,
      },
    }),
  }
)((props) => (
  <BOGraphQLLoader data={props.verification!}>
    <ManualVerification
      user={props.verification.user}
      onUserChanged={props.onUserChanged}
    />
  </BOGraphQLLoader>
));
